// ----------------------------------------------------------------------

import { salesPerson } from "@app/modules/salesperson/slice";

function path(root: string, subLink: string) {
  return `${root}${subLink}`;
}

const ROOTS_APP = "/app";
const ROOTS_AUTH = "/auth";
const ROOTS_DASHBOARD = "";

// ----------------------------------------------------------------------

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  // app: path(ROOTS_APP, "/app"),
  // estimators: path(ROOTS_APP, "/estimators"),
  // estimatorDetails: path(ROOTS_APP, "/estimators/estimator-details"),
  // detailers: path(ROOTS_APP, "/detailers"),
  // users: path(ROOTS_APP, "/users"),
  // detailersDetails: path(ROOTS_APP, "/detailers/detailer-details"),
  // projects: path(ROOTS_APP, "/projects"),
  // purchaser: path(ROOTS_APP, "/purchaser"),
  // estimatorsProjectList: path(ROOTS_APP, "/projects-list"),
  // estimatorProjectDetails: path(ROOTS_APP, "/projects-list/project-details"),
  // detailerProjectList: path(ROOTS_APP, "/estimated-list"),
  // detailerCreateSpool: path(ROOTS_APP, "/estimated-list/create-spool"),
  // assignedSpool: path(ROOTS_APP, "/assigned-spool"),
  // detailersLineNumberDetails: path(
    //   ROOTS_APP,
  //   "/estimated-list/line-number-details"
  // ),
  // inventory: path(ROOTS_APP, "/inventory"),
  // fabricationShop: path(ROOTS_APP, "/fabrication-shop"),
  // scanAndInstall: path(ROOTS_APP, "/scan-and-install"),
  // shipmentAndReceiving: path(ROOTS_APP, "/shipment-and-receiving"),
  // installationReports: path(ROOTS_APP, "/installation-reports"),
  // home: path(ROOTS_DASHBOARD, "/homePage"),
  // testDriveProcess: path(ROOTS_DASHBOARD, "/testDriveProcess"),
  // buy: path(ROOTS_DASHBOARD, "/buy"),
  // productListPage: path(ROOTS_DASHBOARD, "/productListPage"),
  // addProduct: path(ROOTS_DASHBOARD, "/add-product"),
  // categoryPage: path(ROOTS_DASHBOARD, "/category-page"),
  dashboard: path(ROOTS_DASHBOARD, "/dashboard"),
  model: path(ROOTS_DASHBOARD, "/model"),
  addModel: path(ROOTS_DASHBOARD, "/add-model"),
  product: path(ROOTS_DASHBOARD, "/car"),
  customerPage: path(ROOTS_DASHBOARD, "/customers"),
  customerDetails: path(ROOTS_DASHBOARD, "/customers/customer-details"),
  salesPerson: path(ROOTS_DASHBOARD, "/user"),
  brand: path(ROOTS_DASHBOARD, "/brand"),
  productDetail: path(ROOTS_DASHBOARD, "/car/car-detail"),
  editProduct: path(ROOTS_DASHBOARD, "/car/edit-car"),
  changeStatus: path(ROOTS_DASHBOARD, "/requests/buy/change-status"),
  addValuation: path(ROOTS_DASHBOARD, "/requests/sell/add-valuation"),
  assignAgent:  path(ROOTS_DASHBOARD, "/requests/sell/assign-agent"),
  assignSalesPerson: path(ROOTS_DASHBOARD, "/requests/buy/add-sales-person"),
  salesPersonDetails: path(ROOTS_DASHBOARD, "/user/sales-person-details"),
  myProfile: path(ROOTS_DASHBOARD, "/edit-profile"),
  requests: path(ROOTS_DASHBOARD, "/requests"),
  addProduct1: path(ROOTS_DASHBOARD, "/car/add-car"),
  reviews: path(ROOTS_DASHBOARD, "/reviews"),
  testimonials: path(ROOTS_DASHBOARD, "/reviews"),
};

export const PATH_AUTH = {
  login: path(ROOTS_AUTH, "/login-page"),
  signUp: path(ROOTS_AUTH, "/signUp"),
  forgotPassword: path(ROOTS_AUTH, "/forgotPassword"),
  updatePassword: path(ROOTS_AUTH, "/updatePassword"),
};
